<template>
    <div class="clearfix main_center">

        <div class="right-content">
            <el-form ref="form" :model="form" label-width="150px" class="form viewFormWrapper">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>采购项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="项目名称：" size="small">
                                    {{ form.projectName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="项目编号：" size="small">
                                    {{ form.projectCode }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="采购人：" size="small">
                                    {{ form.purchaserName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="采购品目：" size="small">
                                    {{ form.purchaseItem.purchaseItemName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="采购方式：" size="small">
                                    {{ form.purchaseModeName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="重点项目：" size="small">
                                    {{ form.importantProjectName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="采购计划备案号：" size="small">
                                    {{ form.planCode }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="采购预算：" size="small">
                                    {{ form.purchaseBudget }} 元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="最高限价：" size="small">
                                    {{ form.priceCeiling }} 元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="进口产品：" size="small">
                                    {{ form.isImportName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联合体参与：" size="small">
                                    {{ form.isConsortiumName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="政府向社会公众提供的公共服务项目：" label-width="240px" size="small">
                                    {{ form.isPublicProjectName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="其他信息：" size="small">
                                    {{ form.otherInfo }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>采购内容</span>
                    </div>
                    <div class="form-content default-content">
                        <el-table
                                border
                                stripe
                                :data="form.purchaseContentDtos"
                                class="new-table"
                                header-row-class-name="new-table--header">
                            <el-table-column
                                    fixed
                                    type="index"
                                    align="center"
                                    label="序号"
                                    width="80"
                                    :index="getRowsIndex"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="productName"
                                    label="货物(服务)名称"
                                    min-width="180"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="productNum"
                                    label="数量（台/套）"
                                    min-width="100"
                                    show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="propertyName"
                                    label="属性"
                                    min-width="100"
                                    show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="industry"
                                    label="所属行业"
                                    min-width="100"
                                    show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="remarks"
                                    label="要求备注"
                                    min-width="200"
                                    show-overflow-tooltip
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>供应商资格条件</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row style="margin-bottom: 24px">
                            <el-table
                                    border
                                    stripe
                                    :data="purchaseFixedRequireList"
                                    class="new-table"
                                    header-row-class-name="new-table--header">
                                <el-table-column
                                        fixed
                                        type="index"
                                        align="center"
                                        label="序号"
                                        width="80"
                                        :index="getRowsIndex"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="requireName"
                                        label="资格要求"
                                        min-width="180">
                                </el-table-column>
                                <el-table-column
                                        prop="requireContent"
                                        label="资格条件"
                                        min-width="200"
                                >
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="专门面向中小微企业的项目：" label-width="224px" size="small">
                                    {{ form.tendencyMicroName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="form.tendencyMicro == '1'">
                                <el-form-item label="面向企业类型：" size="small">
                                    {{ form.enterpriseTypeName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="form.tendencyMicro == '0'">
                                <el-form-item label="不专门面向中小微企业的原因：" label-width="224px" size="small">
                                    {{ form.microReasonName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="form.tendencyMicro == '1'">
                            <el-col :span="12">
                                <el-form-item label="预留形式：" label-width="224px" size="small">
                                    {{ form.reserveFormName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预留份额：" size="small">
                                    {{ form.reserveShare }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="专门面向残疾人福利企业：" label-width="224px"  size="small">
                                    {{ form.tendencyDisabledName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="专门面向监狱企业：" size="small">
                                    {{ form.tendencyPrisonName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="其他落实政策采购政策的资格要求：" label-width="224px" size="small">
                                    {{ form.otherPolicy }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="特定资格要求：" label-width="224px"  size="small">
                                    {{ form.specificRequire }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>附件信息</span>
                    </div>
                    <template>
                        <div class="affixDown" v-if="form.attachments.length > 0" style="margin-bottom: 10px">
                            <affixDoc
                                    v-for="(item, index) in form.attachments"
                                    :item.sync="item"
                                    labelWidth="224px"
                                    :index="index"
                                    :key="index"
                                    :showModal="false"
                                    :name="item.labelName"
                            >
                            </affixDoc>
                        </div>
                        <p style="text-align: center" v-if="form.attachments.length == 0">暂无附件数据</p>
                    </template>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {httpMixinsDetail, httpGetAttsByBusinessId,httpMixinsCommonPost} from "@/server/purchase";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import affixDoc from "@/components/affixDoc";
    export default {
        components: {
            affixDoc
        },
        data() {
            return {
                form: {
                    purchaseItem:{},
                    attachments:[],
                    purchaseContentDtos:[],
                },
                purchaseFixedRequireList:[],
            }
        },
        created() {
            this.requestPurchasefixedrequireList();
        },
        activated() {
            this.id = this.$route.query.id;
            this.getDataById();
        },
        methods: {
            requestPurchasefixedrequireList(){
                httpMixinsCommonPost('/purchase/purchasefixedrequire/pagedList',{
                    "filter":{},
                    "orderBy":"sort asc",
                    "page":1,
                    "rows":100
                }).then((res) => {
                    if(res.status == 200){
                        this.purchaseFixedRequireList = res.data.rows || [];
                    }
                })
            },
            getRowsIndex(index) {
                return  index + 1
            },
            backBtn() { //返回
                tabsCloseCurrentHandle();
                this.$router.push({
                    name: 'purchaseRequires'
                })
                this.$refs.form.resetFields();
            },
            getDataById() { //详情
                if (this.id != "") {
                    httpMixinsDetail('/purchase/project/get/' + this.id).then((res) => {
                        if (res.data.code === '1') {
                            const data = res.data.data;
                            this.form = {...data};
                            httpGetAttsByBusinessId('purchase_project', this.id,  true).then((resData) => {
                                let resAttachment = resData.data.map(item => {
                                    return {
                                        ...item,
                                        disabledUpload: false,
                                    }
                                })
                                this.$set(this.form,'attachments',resAttachment)
                            })
                        }
                    })
                }
            },
        }


    }
</script>

<style lang="less" scoped>
    .angle_tag{
        margin-right: 10px !important;
    }
</style>